import React from 'react'
import SmartNavigator from '../generic/SmartNavigator'
import StorageTraceability from '../management/StorageTraceability'
import { useSmartTranslation } from '../generic/hooks/useSmartTranslation'

const MainStorageTraceability = () => {
  const { t_ } = useSmartTranslation()
  const componentsInfo = [
    {
      title: t_('Storage Traceability'),
      component: <StorageTraceability />
    }
  ]
  return <SmartNavigator componentsInfo={componentsInfo} />
}
export default MainStorageTraceability
